import React from 'react';
import { Dashboard } from './Dashboard';
import { formatSupersetDate } from '../../helpers/dates';

export type KeywordCrossCheck = {
  config: {
    isNumeric: boolean;
  };
  params: {
    responses: string;
    keyword: string;
    nameString: string;
    dateCreated: string;
  };
};

type KeywordCrossCheckDashboardProps = KeywordCrossCheck['params'] &
  KeywordCrossCheck['config'] & {
    brandId: number;
  };

export function KeywordCrossCheckDashboard(
  props: KeywordCrossCheckDashboardProps,
) {
  const { brandId, isNumeric, responses, keyword, nameString, dateCreated } =
    props;

  return (
    <Dashboard
      id='0c6a6caa-288f-4a6a-8012-9513a16677a7'
      dashboardUiConfig={{
        hideTitle: true,
        hideTab: true,
        hideChartControls: true,
        filters: {
          visible: false,
          expanded: false,
        },
        urlParams: {
          local_date: formatSupersetDate(new Date(dateCreated)),
          responses: responses,
          key: keyword,
          name_string: nameString,
          numeric: isNumeric ? 'Yes' : 'No',
          brand_id: brandId,
        },
      }}
    />
  );
}
